const c = {
  name: "EmoticonLove",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11.5,28.5c2.2,2.2,5.2,3.5,8.5,3.5s6.3-1.3,8.5-3.5l-1.4-1.4C25.3,28.9,22.8,30,20,30s-5.3-1.1-7.1-2.9
			L11.5,28.5z"/>
		<path class="st0" d="M12,13.4c-0.7-0.8-1.8-1.4-3-1.4c-1,0-2,0.3-2.8,1C5.4,13.7,5,14.8,5,16c0,2.5,1.8,4.5,3.4,5.8
			c0.8,0.7,1.6,1.2,2.2,1.6c0.3,0.2,0.5,0.3,0.7,0.4c0.1,0,0.2,0.1,0.2,0.1l0,0l0,0l0,0l0,0l0,0c0,0,0,0,0.4-0.9l-0.4,0.9l0.4,0.2
			l0.4-0.2l0,0l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0.2-0.1c0.2-0.1,0.4-0.2,0.7-0.4c0.6-0.4,1.4-0.9,2.2-1.6
			c1.5-1.3,3.4-3.3,3.4-5.8c0-1.2-0.4-2.3-1.2-3C17,12.3,16,12,15,12C13.8,12,12.7,12.5,12,13.4z M7.6,14.5C7.9,14.2,8.4,14,9,14
			c1.1,0,2,0.9,2,2h2c0-1.1,0.9-2,2-2c0.6,0,1.1,0.2,1.4,0.5c0.3,0.3,0.6,0.8,0.6,1.5c0,1.5-1.2,3-2.6,4.2c-0.7,0.6-1.4,1.1-1.9,1.4
			c-0.2,0.1-0.3,0.2-0.4,0.2c-0.1-0.1-0.3-0.2-0.4-0.2c-0.5-0.3-1.2-0.8-1.9-1.4C8.2,19,7,17.5,7,16C7,15.2,7.2,14.8,7.6,14.5z
			 M12.4,23.9L12,23C12.4,23.9,12.4,23.9,12.4,23.9z"/>
		<path class="st0" d="M25,12c1.2,0,2.3,0.5,3,1.4c0.7-0.8,1.8-1.4,3-1.4c1,0,2,0.3,2.8,1c0.8,0.7,1.2,1.7,1.2,3
			c0,2.5-1.8,4.5-3.4,5.8c-0.8,0.7-1.6,1.2-2.2,1.6c-0.3,0.2-0.5,0.3-0.7,0.4c-0.1,0-0.2,0.1-0.2,0.1c0,0,0,0-0.1,0l0,0l0,0l0,0
			L28,23c-0.4,0.9-0.4,0.9-0.4,0.9l0,0l0,0l0,0c0,0,0,0-0.1,0c0,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.2-0.7-0.4
			c-0.6-0.4-1.4-0.9-2.2-1.6C22.8,20.5,21,18.5,21,16c0-1.2,0.4-2.3,1.2-3C23,12.3,24,12,25,12z M23,16c0,1.5,1.2,3,2.6,4.2
			c0.7,0.6,1.4,1.1,1.9,1.4c0.2,0.1,0.3,0.2,0.4,0.2c0.1-0.1,0.3-0.2,0.4-0.2c0.5-0.3,1.2-0.8,1.9-1.4C31.8,19,33,17.5,33,16
			c0-0.8-0.2-1.2-0.6-1.5C32.1,14.2,31.6,14,31,14c-1.1,0-2,0.9-2,2h-2c0-1.1-0.9-2-2-2c-0.6,0-1.1,0.2-1.4,0.5
			C23.2,14.8,23,15.2,23,16z"/>
		<path class="st0" d="M28,23l-0.4,0.9l0.4,0.2l0.4-0.2C28.4,23.9,28.4,23.9,28,23z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18
			c9.9,0,18,8.1,18,18c0,9.9-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as EmoticonLove
};
